import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import React from "react";
import { useContact } from "utilities/api/contactQuery";

interface ChooseContactRadioProps {
  contactOptions: server.dto.ContactSmallV2[]

  selectedContact: server.dto.ContactSmallV2 | null
  onContactSelected: (contact: server.dto.ContactSmallV2 | null) => void
  onContactEdited: () => void
}

export const ChooseContactRadio = (props: ChooseContactRadioProps) => {

  const onContactSelected = (contactId: number) => {
    if (contactId === -1) {
      props.onContactSelected(null);
    } else {
      const contact = props.contactOptions.find(c => c.contactId === contactId);
      props.onContactSelected(contact);
    }
  }

  return <RadioGroup
    orientation="vertical"
    options={[
      { label: RESX.Contact.NobodySelected, value: -1 },
      ...props.contactOptions.map(c => ({
        label: <ContactLabel contact={c} />,
        value: c.contactId
      }))
    ]}
    value={props.selectedContact ? props.selectedContact.contactId : -1}
    onChange={onContactSelected}
  />
}

interface ContactLabelProps {
  contact: server.dto.ContactSmallV2
}

const ContactLabel = (props: ContactLabelProps) => {
  const contact = useContact(props.contact);
  return <div onClick={(e) => {
    // This is needed to prevent the radio button from being selected when clicking on the contact link in the label.
    e.preventDefault();
  }} className="flex gap align-center">
    <div>
      <ContactSidePanel
        contactId={contact.contactId}
        trigger={<a>{contact.name.fullName}</a>}
      />
      <div className="text-sublabel">{contact.position}</div>
    </div>
  </div>
}